import nordeaInvoiceExportReport from '../../assets/js/report/invoice_export/invoice'
import nordeaInvoiceLogExportReport from '../../assets/js/report/invoice_export/invoice_log'
export default {
  methods: {
    exportToNordea (ids, toAddresses, isFromInvoice = false, langs, type) {
      return new Promise((resolve, reject) => {
        this.nordeaLoading = true
        this.$_executeApi('post', 'invoices/get_invoice_for_nordea', { ids })
          .then(response => {
            const result = response.data
            let invoiceshtml = this.invoiceHeadContent()
            let invoicelogghtml = ''
            result.invoices.map((x, index) => {
              const customer = x.invoice.customerdata ? JSON.parse(x.invoice.customerdata || {}) : {}
              let getCustomerLang = customer.Language ? customer.Language : this.$i18n.locale
              let lang = getCustomerLang ? this.$i18n.messages[getCustomerLang].message : this.$i18n.messages[this.$i18n.locale].message
              const headers = [{ text: lang.invoiceReport.line, value: 'number', reportWidth: '23%' },
                { text: lang.invoiceReport.productDescription, value: 'description', reportWidth: '40%' },
                { text: lang.order.qty, value: 'qty', reportWidth: '5%' },
                { text: '', value: 'unitname', reportWidth: '0%' },
                { text: lang.orders.price, value: 'base_price', reportWidth: '12%' },
                { text: lang.product.discount, value: 'discount', reportWidth: '8%' },
                { text: lang.invoice.sum, value: 'sum_ex_vat', reportWidth: '12%' }]

              let translations = {
                telephone: lang.invoiceReport.telephone,
                email: lang.customer.email,
                web: lang.customer.web,
                business: lang.invoiceReport.businessEnterprises,
                orgNo: lang.invoiceReport.orgNo,
                accNo: lang.invoiceReport.accNo,
                orderNo: lang.invoiceReport.orderNo,
                invoiceAddress: lang.orders.invoiceAddress,
                deliveryAddress: lang.orders.deliveryAddress,
                ourRef: lang.invoiceReport.ourRef,
                yourRef: lang.invoiceReport.yourRef,
                ourReference: lang.invoiceReport.ourReference,
                yourReference: lang.invoiceReport.yourReference,
                saleRef: lang.invoiceReport.saleRef,
                betBet: lang.invoiceReport.betBet,
                paymentTerms: lang.invoiceReport.paymentTerms,
                levBet: lang.invoiceReport.levBet,
                deadline: lang.invoiceReport.deadline,
                customerNo: lang.invoiceReport.customerNo,
                orderDate: lang.whOrder.orderDate,
                invoiceDate: lang.invoiceReport.invoiceDate,
                dueDate: lang.invoice.duedate,
                delivery: lang.customer.delivery,
                installed: lang.customer.installed,
                customerInfo: lang.invoiceReport.customerInfo,
                tel: lang.invoiceReport.tel,
                mobile: lang.invoiceReport.mobile,
                totalExVat: lang.orders.totalExVat,
                vat: lang.customer.vatValue,
                roundOff: lang.invoiceReport.roundOff,
                totalIncVat: lang.invoiceReport.totalIncVat,
                kid: lang.invoiceReport.kid,
                amountPay: lang.invoiceReport.amountToPay,
                payDeadline: lang.invoiceReport.paymentDeadline,
                accNumber: lang.customer.accountnumber,
                stdSale: lang.orders.standardSales,
                deliveryTerms: lang.orders.deliveryTerms,
                invoice: lang.customer.invoice,
                creditNote: lang.invoice.creditNote,
                yourOrderNumber: lang.orders.yourOrderNumber,
                yourContactPerson: lang.order.yourContactPerson,
                comments: lang.common.comments,
                labeled: lang.invoiceReport.labeled
              }
              invoiceshtml += nordeaInvoiceExportReport(headers, x, translations, type)
            })
            invoiceshtml += `</body></html>`
            invoiceshtml = btoa(unescape(encodeURIComponent(invoiceshtml)))
            invoicelogghtml = nordeaInvoiceLogExportReport(result)
            if (!isFromInvoice) {
              resolve()
              let model = { invoiceshtml, invoicelogghtml, invoiceids: ids, to: toAddresses, type }
              this.$_executeApi('post', `invoices/generate_and_share_nordea`, model)
                .then((response) => {
                  if (response.data) {
                    this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.exportedSuccess') })
                    if (this.invoiceObj && this.invoiceObj.selection) this.invoiceObj.selection = []
                    if (type === 1) {
                      window.open(`${process.env.VUE_APP_URL}file/download/?fileName=${response.data}`, '_blank')
                    }
                    this.getListHandler()
                  }
                })
                .finally(() => {
                  this.showEmailDialog = false
                  this.nordeaLoading = false
                  this.$eventBus.$emit('closeExportMailDialog')
                })
            } else {
              this.nordeaLoading = false
              resolve(invoiceshtml)
            }
          })
          .catch((err) => {
            console.log(err)
            this.previewLoader = false
            this.nordeaLoading = false
            this.showEmailDialog = false
            this.$eventBus.$emit('closeExportMailDialog')
          })
      })
    },
    invoiceHeadContent () {
      return `
      <html>
        <head>
          <meta content="text/html; charset=utf-8" http-equiv="Content-Type"/>
          <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap.min.css">
          <style>
            body {
              font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;

              font-size: 16px !important;
            }
            .information-box {
              padding-left: 4px;
              padding-top: 1px;
              border: 1px solid;
              background: white;
            }
            .margin-adjustments {
              margin-top:2px !important;
              margin-bottom:2px !important;
            }
            .zero-h-margin-padding {
              margin-left:0px !important;
              margin-right:0px !important;
              padding-left:0px !important;
              padding-right:0px !important;
            }
            .total-info {
              width: 40%;
              border: 3px solid;
              padding: 5px;
            }
            thead tr { page-break-inside:avoid; }
            tbody tr { page-break-inside:avoid; }
            .address-box { min-height: 100px; }
            .info-box-height { min-height: 80px; }
            .info-boxes>div, .noso_info { padding-left: 5px !important;padding-right: 5px !important;}
            .border { border: 1px solid #dddddd; }
            .noso_info div { padding-right: 0px !important; }
            .mt-4 { margin-top: 4%; }
            thead { display: table-header-group; }
            tfoot { display: table-row-group; }
            .container-fluid { page-break-before: always; }
            .table-invoice-items table tr, .table-invoice-items table tr td { page-break-inside: avoid; }
            .table-invoice-items tr td, .table-invoice-items tr th { font-size: 16px; }
            tbody tr td { text-align: justify;word-break: break-word;padding: 2px !important;}
            thead tr td, thead tr th { text-align: justify;word-break: break-word;padding: 2px !important;}
            .table-invoice-items tbody tr td, .table-invoice-items thead tr td, .table-invoice-items tbody tr th, .table-invoice-items thead tr th { border: none; }
          </style>
        </head>
        <body>`
    }
  }
}
